import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'biz-fr-config-list',
  templateUrl: './fr-config-list.component.html',
  styleUrls: ['./fr-config-list.component.scss']
})
export class FrConfigListComponent implements OnInit {
  public searchValue = "";

  @Input() connectors: IFormsRecognizer[];
  @Input() selectedConnector: IFormsRecognizer;
  @Input() isLoading: boolean;
  @Output() onSelectConnector : EventEmitter<IFormsRecognizer> = new EventEmitter<IFormsRecognizer>();

  constructor() { }

  ngOnInit() {
  }

  public selectConnector(connector: IFormsRecognizer) {
    this.onSelectConnector.emit(connector);
  }
}
